import { RESPONSE_REQUEST } from "../actions/actionsTypes";

const requestReducer = (state = [], action) => {
  switch (action.type) {
    case RESPONSE_REQUEST: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default requestReducer;



// WEBPACK FOOTER //
// ./src/reducers/request.js